import React from 'react';
import PropTypes from 'prop-types';
import { PasswordReset } from 'react-cognito';
import { EMPTY_OBJECT } from '../../constants';
import Button from '../Button';
import Link from '../Link';
import { Brandmark } from '../Icons';
import SecondaryAction from '../SecondaryAction';
import Style from '../Style';
import { H3, L2, P1, P2 } from '../Typography';

class ForgotPasswordForm extends React.PureComponent {
  static propTypes = {
    error: PropTypes.string,
    sendVerificationCode: PropTypes.func,
    onAfterSendResetCode: PropTypes.func,
    onCancel: PropTypes.func,
  };
  static defaultProps = {
    onAfterSendResetCode: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      formEnabled: true,
      email: '',
      code: '',
      password: '',
      message: '',
      error: '',
    };
  }

  sendVerificationCode = e => {
    e.preventDefault();

    if (!this.state.formEnabled) {
      return;
    }

    if (this.state.email.length < 5) {
      this.setState({ error: 'Please enter an email address.' });
      return;
    }

    this.setState({ fetching: true, formEnabled: false, error: '' });
    this.props
      .sendVerificationCode(this.state.email)
      .then(() =>
        this.setState({
          fetching: false,
          message: 'Verification code sent',
          error: '',
        }),
      )
      .then(() => this.props.onAfterSendResetCode())
      .catch(err => {
        const stateUpdate = { fetching: false, formEnabled: true };
        if (err.code === 'UserNotFoundException') {
          stateUpdate.error = 'User not found';
        } else {
          stateUpdate.error = err.message;
        }
        this.setState(stateUpdate);
      });
  };

  changeInput = e => {
    this.setState({ error: '' });
    if (e.target.type === 'checkbox') {
      this.setState({ [e.target.name]: !this.state[e.target.name] });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  onFocus = e => {
    this.setState({ focus: e.target.name });
  };

  onBlur = e => {
    if (this.state.focus === e.target.name) {
      this.setState({ focus: undefined });
    }
  };

  render() {
    const formBaseStyle = {
      border: 'none',
      width: '100%',
    };

    const inputBaseStyle = {
      ...formBaseStyle,
      color: Style.Colors.shadow3,
      opacity: 0.5,
      borderBottom: `0.1rem solid ${Style.Colors.shadow3}`,
    };
    const labelBaseStyle = {
      ...formBaseStyle,
      color: Style.Colors.shadow3,
      opacity: 0.5,
      fontStyle: 'italic',
      fontWeight: 'light',
      fontSize: '2.6rem',
      letterSpacing: -0.18,
      marginTop: '2.5rem',
      display: 'block',
    };
    const inputFocusStyle = {
      opacity: 1,
    };
    const labelFocusStyle = {
      opacity: 1,
    };

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '5rem 6rem',
        }}
      >
        <div>
          <Brandmark />
        </div>
        <H3 style={{ marginTop: '3rem' }}>Reset your password?</H3>
        <form
          style={{
            ...formBaseStyle,
            ...{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            },
          }}
          onSubmit={this.sendVerificationCode}
        >
          <label
            style={{
              ...labelBaseStyle,
              ...(this.state.focus === 'email' || this.state.email.length > 0
                ? labelFocusStyle
                : EMPTY_OBJECT),
            }}
          >
            <div>
              <L2 style={{ color: 'inherit' }}>YOUR EMAIL</L2>
            </div>
            <input
              style={{
                ...inputBaseStyle,
                ...(this.state.email.length > 0
                  ? inputFocusStyle
                  : EMPTY_OBJECT),
              }}
              name="email"
              type="email"
              value={this.state.email}
              onChange={this.changeInput}
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              required
            />
          </label>
        </form>

        <div
          style={{
            width: '100%',
            textAlign: 'left',
            color: Style.Colors.error,
          }}
        >
          <P1>
            {this.state.error ||
              this.props.error ||
              this.state.message || <span>&nbsp;</span>}
          </P1>
        </div>

        <Button
          style={{ marginTop: '3rem' }}
          type="submit"
          onClick={this.sendVerificationCode}
          working={this.state.fetching}
          arrow={true}
        >
          Send Reset Code
        </Button>
        <SecondaryAction onClick={this.props.onCancel}>Cancel</SecondaryAction>
      </div>
    );
  }
}

export default props => {
  return (
    <PasswordReset>
      <ForgotPasswordForm {...props} />
    </PasswordReset>
  );
};



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordForm/ForgotPasswordForm.js